module.exports = __webpack_public_path__ + "static/media/open-menu.646ced42.svg";